export class Trpdbvoucher {
    public V_ID!: number;
    public V_LOCID!: number;
    public V_NO!: string;
    public V_TYPE!: string;
    public V_DATE!: string;
    public V_AMOUNT!: number;
    public LEDGER_CODE!: string;
    public REF_NO!: string;
    public V_PAYMODE!: number;
    public V_CHEQUENO!: string;
    public REF_TYPE!: string;
    public V_BANKCODE!: string;
    public V_NARRATION!: string;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string;
    public UPDATED_DATE!: string;
    public IS_ACTIVE!: boolean;
    public CrDr!: string;
}
